import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { OptionsListElement } from '../../../Blocks/components/common/StyledEditables';

const Visible = ({ isVisible }) =>
<>
    <OptionsListElement style={isVisible ? { display: 'none' } : {}}>
      <Icon
      name="hide"
      color="white"
      size={24} />

    </OptionsListElement>
    <OptionsListElement style={!isVisible ? { display: 'none' } : {}}>
      <Icon
      name="show"
      color="white"
      size={24} />

    </OptionsListElement>
  </>;


export default Visible;